import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-youth-festival',
  templateUrl: './youth-festival.component.html',
  styleUrls: ['./youth-festival.component.scss']
})
export class YouthFestivalComponent implements OnInit {

  festivalImages = [
    '/assets/img/campus/3.jpg',
    '/assets/img/campus/9.jpg',
    '/assets/img/campus/4.jpg',
    '/assets/img/campus/1.jpg'
  ];

  constructor() { }

  ngOnInit(): void { }

}
